export const EMAIL = 'info@dluhopisomat.cz'
export const supportPhone = '+420 779 998 119'
